module.exports = __webpack_public_path__ + "static/media/dw-logo-line.9d054717.svg";